<template>
    <label
      class="container"
      :class="optionClass"
      :style="optionClass === 'checked' ? 'background: ' + chatbotColors.sentMessage.bg + '; color: ' + chatbotColors.sentMessage.text + ';' : ''"
    >
        <input type="checkbox" :value="option.key" v-model="model" :disabled="lastMessage === false"> {{ option.value }}
    </label>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    white: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Array,
      required: false,
      default: () => []
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    optionClass () {
        return this.model.find(item => item === this.option.key)
            ? 'checked'
            : (this.white ? 'white' : '');
    }
  },
}
</script>

<style lang="scss" scoped>
  .container {
    max-width: 100%;
    display: flex;
    align-items: center;
    background: #eaeaea;
    padding: 5px 10px;
    font-size: 0.8rem;
  }
  .container.white {
    background: #f3f3f3;
  }
  .container.checked {
    color: white;
  }
  .container input {
    margin-right: 10px;
  }
</style>
